import $ from 'jquery';
import PageApp from 'pageApp';
import Util from '../util/Util';
import FCCZone from '../data/processor/FCCZone';
import Constants from '../util/Constants';

const FCC = {


  fccUrl(argCategoryId, sortingOrder) {
    let categoryId = argCategoryId;
    if (!categoryId || categoryId === -9 || categoryId === '-9') {
      categoryId = Constants.DEFAULT_FCC_CATEGORY_ID;
    }
    let url = Constants.PATH_FCC_RECOMMENDATIONS.replace(/CATEGORY_ID/, categoryId);
    if (sortingOrder) {
      url = `${url}&_sortby=${sortingOrder}`;
    } else {
      url = `${url}&_sortby=BEST_SELLERS`;
    }
    return url;
  },

  triggerFailureForOtherZones(request) {
    if (!request || !request.zone) { return; }
    const zone = Util.otherThanFallbackZones(request.zone);

    if (zone) {
      zone.split('|').forEach((_zone) => {
        const config = Object.assign({}, request, { zone: _zone });
        PageApp.channel.trigger(Util.failureEvent(config), config);
      });
    }
  },

  getRecommendations(request, properties = {}) {
    return new Promise((resolve, reject) => {
      if (!request || !request.zone) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          error: 'Recommendation getFccRecommendations parameters are not correct',
          opts: request,
        });

        return;
      }

      $.ajax({
        type: 'GET',
        url: this.fccUrl(request.categoryId, properties.fccSortOrder),
        timeout: request.timeout,
        dataType: 'json',
        headers: {
          'X-Macys-ClientId': 'PROS',
        },
      }).done((fccResponse) => {
        this.triggerFailureForOtherZones(request);
        resolve(FCCZone.recommendation(fccResponse, request));
      }).fail(() => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ error: 'FCC recommendation failed', config: request });
      });
    });
  },

};


export default FCC;
